import { Component, OnInit } from '@angular/core';
//import { RouterLinkInfoService } from 'src/app/service/router-link-info.service';
import * as $ from "jquery";
import { RouterLinkInfoService } from 'src/app/services/router-link-info.service';

@Component({
  selector: 'app-habit-tracker-master',
  templateUrl: './habit-tracker-master.component.html',
  styleUrls: ['./habit-tracker-master.component.css']
})
export class HabitTrackerMasterComponent implements OnInit {
  public Linechart = [];  
  constructor(private routerinfoservice:RouterLinkInfoService) { }

  ngOnInit() {
  }
  onActivate(componentRef){
    try{
      var currentUrl = window.location.pathname;
      // var me =  componentRef.getPageName();
      // this.CData =me;
      $('#breadItem').text(this.routerinfoservice.getPageName(currentUrl));
    }
    catch(ex){
  //this.CData = 'Not set';
    }
}
}
